export function maskInsurance(toBeMasked: string, unmaskedLength = 4) {
	if (!toBeMasked || toBeMasked.length <= unmaskedLength) {
		return toBeMasked;
	}

	if (unmaskedLength === 0) {
		return 'x'.repeat(toBeMasked.length);
	}

	const maskCount = toBeMasked.length - unmaskedLength;
	const unmasked = toBeMasked.slice(-unmaskedLength);

	return `${'x'.repeat(maskCount)}${unmasked}`;
}
